<template lang="pug">
  div(class="message-container")
    // Контейнер с сообщениями
    div(class="message-container__content mb-2" ref="messageContent")
      div(
        v-for="(m, i) in messages"
        :key="i"
        class="message-container__message"
        :class="`message-container__message--${ m.isMine ? 'mine' : 'participant' }`"
      )
        div(
          class="message"
          :class="`message--${ m.isMine ? 'mine' : 'participant' }`"
        )
          div(class="message__content") {{ m.message }}
          div(class="message__info") {{ m.author }}, {{ m.date }}

    // Кнопка "Загрузить больше", переместить наверх
    div(v-if="false" class="message-container__input")
      v-btn.my-4(@click="loadMore" color="warning" rounded small) Тестовая кнопка - Загрузить больше

    // Ввод сообщения
    div(class="message-container__input")
      v-textarea(
        v-model="message"
        ref="messageInput"
        @keydown.enter.exact.prevent
        @keyup.enter.exact="sendMessage"
        :rows="rows"
        label="Введите сообщение"
        class="rounded-xl"
        filled hide-details rounded
      )
        template(v-slot:prepend)
        template(v-slot:append-outer)
          v-btn(icon title="Прикрепить файл")
            v-icon mdi-attachment
          v-btn.mt-4(@click="sendMessage" color="primary" title="Отправить сообщение" icon)
            v-icon mdi-send
</template>

<script>
import { mapGetters } from 'vuex';
import { format, parseISO } from 'date-fns';
import { Centrifuge } from 'centrifuge';

export default {
  name: 'ChatWindow',
  props: {
    groupId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      chatRoomId: null,
      message: '',
      messages: [],
      rows: 3,
      centrifuge: null,
    };
  },
  computed: {
    ...mapGetters({ userData: 'auth/userData' }),
  },
  mounted() {
    if (this.groupId) {
      this.$rHandler(
        this.$api.chat.getRoomGroup(this.groupId),
        (r) => {
          this.chatRoomId = r.data.data.id;
          this.setCentrifuge(r.data.data.url, r.data.data.token, r.data.data.channel);
          this.getMessageHistory();
        },
      );
    }
    this.$nextTick(() => {
      this.$refs.messageContent.scrollTop = this.$refs.messageContent.scrollHeight;
    });
  },
  beforeDestroy() {
    this.centrifuge.disconnect();
  },
  methods: {
    sendMessage() {
      const data = {
        message: this.message,
      };
      this.$rHandler(
        this.$api.chat.sendMessage(this.chatRoomId, data),
        () => {
        },
      );
      this.message = '';
    },
    setCentrifuge(url, token, channel) {
      this.centrifuge = new Centrifuge(url, { token });
      const sub = this.centrifuge.newSubscription(channel);

      sub.on('publication', (ctx) => this.addMessagesToChat([ctx.data.data]));
      sub.subscribe();

      this.centrifuge.connect();
    },
    getMessageHistory(offset) {
      const config = {
        params: {
          sort: '-created_at',
          offset,
        },
      };
      this.$rHandler(
        this.$api.chat.getMessages(this.chatRoomId, config),
        (r) => {
          this.addMessagesToChat(r.data.data.reverse(), offset);
        },
      );
    },
    addMessagesToChat(messages, offset) {
      const formattedMessages = messages.map((m) => ({
        message: m.message,
        date: format(parseISO(m.created_at), 'HH:mm - dd.MM.yyyy'),
        // date: '00:00, 01.01.1970',
        author: m.user_name,
        isMine: this.userData.id === m.owner_id,
      }));

      if (offset) {
        this.messages.unshift(...formattedMessages);
      } else {
        this.messages.push(...formattedMessages);
        this.scrollToBottom();
      }
    },
    loadMore() {
      this.getMessageHistory(this.messages.length);
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.messageContent.scrollTop = this.$refs.messageContent.scrollHeight;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.message-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  &__content {
    flex: 1 0 0;
    border-left: 2px solid rgba(0,0,0, 0.08);
    padding: 10px;
    overflow-y: scroll;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      width: 6px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: inherit;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background-color: var(--v-primary-base);
      border-radius: 15px;
      height: 4px;
      width: 4px;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background-color: var(--v-primary-base);
    }
  }

  &__input {
    flex: 0;
  }

  &__message {
    display: flex;

    &--participant {
      margin-right: 20px;
    }

    &--mine {
      margin-left: 20px;
      justify-content: flex-end;
    }
  }

  .message {
    background-color: #f2f2f2;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 8px;

    &__content {
      white-space: pre-wrap;
    }

    &__info {
      margin-top: 4px;
      text-align: right;
      font-size: .7rem;
      color: #777;
    }

    &--mine {
      background-color: var(--v-primary-base);
      color: #fff;

      .message__info{
        color: #ccc;
      }
    }
  }

  ::v-deep .v-input__prepend-outer,
  ::v-deep .v-input__append-outer {
    margin: auto 6px auto 6px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}

.theme--dark .message--participant  {
  background-color: rgba(255, 255, 255, 0.08);
}

textarea {
  scroll-behavior: smooth;
}
</style>
